import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

type SortColumn = 'memberNumber' | 'email' | 'plan' | 'registeredAt' | 'aiCredits' | 'referralCode' | 'salesAmount' | 'status' | 'role';
type SortDirection = 'asc' | 'desc';

interface MemberListHeaderProps {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
}

export function MemberListHeader({ sortColumn, sortDirection, onSort }: MemberListHeaderProps) {
  const getSortIcon = (column: SortColumn) => {
    if (sortColumn !== column) return null;
    return sortDirection === 'asc' ? (
      <ArrowUp className="w-4 h-4 ml-1" />
    ) : (
      <ArrowDown className="w-4 h-4 ml-1" />
    );
  };

  const getSortableButtonClass = (column: SortColumn) => {
    const baseClass = "flex items-center hover:bg-gray-100 transition-colors cursor-pointer flex-1 min-w-0 text-left";
    return sortColumn === column 
      ? `${baseClass} text-blue-600 font-medium`
      : `${baseClass} text-gray-500`;
  };

  return (
    <div className="hidden lg:grid lg:grid-cols-9 gap-4 px-6 py-3 bg-gray-50 text-sm font-medium text-gray-500 rounded-t-lg">
      <button 
        onClick={() => onSort('memberNumber')}
        className={`${getSortableButtonClass('memberNumber')}`}
      >
        会員ID
        {getSortIcon('memberNumber')}
      </button>
      <button 
        onClick={() => onSort('email')}
        className={getSortableButtonClass('email')}
      >
        メールアドレス
        {getSortIcon('email')}
      </button>
      <button 
        onClick={() => onSort('plan')}
        className={getSortableButtonClass('plan')}
      >
        プラン
        {getSortIcon('plan')}
      </button>
      <button 
        onClick={() => onSort('registeredAt')}
        className={getSortableButtonClass('registeredAt')}
      >
        登録日
        {getSortIcon('registeredAt')}
      </button>
      <button 
        onClick={() => onSort('aiCredits')}
        className={getSortableButtonClass('aiCredits')}
      >
        AIクレジット
        {getSortIcon('aiCredits')}
      </button>
      <button 
        onClick={() => onSort('referralCode')}
        className={getSortableButtonClass('referralCode')}
      >
        紹介者コード
        {getSortIcon('referralCode')}
      </button>
      <button 
        onClick={() => onSort('salesAmount')}
        className={getSortableButtonClass('salesAmount')}
      >
        売上金
        {getSortIcon('salesAmount')}
      </button>
      <button 
        onClick={() => onSort('status')}
        className={getSortableButtonClass('status')}
      >
        ステータス
        {getSortIcon('status')}
      </button>
      <button 
        onClick={() => onSort('role')}
        className={getSortableButtonClass('role')}
      >
        ロール
        {getSortIcon('role')}
      </button>
    </div>
  );
}